import { Form } from 'antd';
import { MemberWrapper } from '../member-wrapper';
import { StepCompProps } from '../../add-member';
import { CheckBox } from './checkbox';
import TextArea from './textArea';
import cx from './index.module.scss';

const options = {
  physicalAssessment: [
    '气虚',
    '阳虚',
    '阴虚质',
    '痰湿质',
    '湿热质',
    '血瘀质',
    '气郁质',
    '特禀质',
    '肩颈酸痛',
    '腰背酸痛',
    '肌肉拉伤',
    '肠胃不适',
    '睡眠困难',
    'Others',
  ],
  adjustmentPurpose: ['体质调理', '减肥瘦身', '痛症舒缓', '体态调整', 'Others'],
};

const OtherInfoStep = (props: StepCompProps) => {
  const { hidden, hasHopeType } = props;

  return (
    <div className={cx('others-info')}>
      <Form.Item hidden={hidden || hasHopeType} name="physicalAssessment" labelAlign="right">
        <MemberWrapper title="健康情况">
          <CheckBox options={options?.physicalAssessment} name="PHYSICAL_ASSESSMENT" othersText="其他情况" />
        </MemberWrapper>
      </Form.Item>
      <Form.Item hidden={hidden || hasHopeType} name="adjustmentPurpose" labelAlign="right">
        <MemberWrapper title="调理诉求">
          <CheckBox options={options?.adjustmentPurpose} name="ADJUSTMENT_PURPOSE" othersText="其他诉求" />
        </MemberWrapper>
      </Form.Item>
      <Form.Item hidden={hidden} name="remark" labelAlign="right">
        <MemberWrapper title="备注">
          <TextArea maxLength={40} placeHolderText="可备注顾客更多信息" />
        </MemberWrapper>
      </Form.Item>
    </div>
  );
};

export { OtherInfoStep };
